import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import "./styles.css";
// import ShowingCard from '../../components/ShowingCard'
import withDrawer from "../../components/withDrawer";
import {
  Button,
  Dialog,
  Card,
  CardContent,
  TextField
} from "@material-ui/core";
import { createAndStartEvent } from "../../actions/events";
import MenuBar from "../../components/MenuBar";
import { CircularProgress } from "@material-ui/core";
import listEvents from "../../lib/listEvents";
import GhostShowing from "../../components/GhostShowing";
import MembershipModal from "../../components/membershipModal";
import { checkSubscription } from "../../actions/subscribe";
import { openSnackBar } from "../../actions/snack-bar";

class Showings extends React.Component {
  state = {
    loadIndex: 1,
    isGhost: false, // inital cards to show
    isSent: false,
    payModal: false,
    openHouseMinutes: 0,
    openHouseHours: 2
  };

  handleNewShowing = (history, id) => () => {
    history.push(`/showings/start/${id}`);
  };

  handleCreateNewShowing = (e, history, bool) => {
    this.setState({ isSent: true });
    const user = this.props.authentication.authenticatedUser;
    if (user && user.contacts.length === 0) {
      this.props.dispatch(
        openSnackBar({
          message: "add atleast 1 emergency contact"
        })
      );
      this.setState({ isSent: false });
    } else {
      let eventLength = 0;
      if (bool) {
        eventLength = Number(this.state.openHouseHours) * 60;
        // + Number(this.state.openHouseMinutes)
      }
      if (bool && Number(this.state.openHouseHours) < 2) {
        this.props.dispatch(
          openSnackBar({
            message: "minimum 2 hours required"
          })
        );
        this.setState({
          isSent: false
        })
      } else {
      let myEvents;
      if (user && user.events && user.events.length > 0) {
        myEvents = user.events.filter(x => x.creator_id === user.id);
      }
      if (!myEvents) {
        let defObj = {};
        this.props.dispatch(createAndStartEvent(defObj, history, eventLength));
      } else {
        this.props.dispatch(checkSubscription(user.id)).then(res => {
          if (res.message) {
            if (res.ending && (res.next * 1000 < new Date().getTime())) {
              this.setState({ payModal: true });
            } else {
              let defObj = {};
              this.props.dispatch(
                createAndStartEvent(defObj, history, eventLength)
              );
            }
          } else {
            if (!res.is_premium) {
              this.setState({ payModal: true });
            } else {
              let defObj = {};
              this.props.dispatch(
                createAndStartEvent(defObj, history, eventLength)
              );
            }
          }
        });
      }
      this.setState({
        isSent: false
      })
    }
    }
  };

  handleLoadMore = () => {
    this.setState({
      loadIndex: this.state.loadIndex + 5
    });
  };

  isActiveShowing() {
    // console.log(this.state)
  }

  componentDidMount = async () => {
    var uri = window.location.toString();
    if (uri.indexOf("?") > 0) {
    var clean_uri = uri.substring(0, uri.indexOf("?"));
    window.history.replaceState({}, document.title, clean_uri);
}
    const myEvents = this.props.authentication.authenticatedUser.events;
    const myID = this.props.authentication.authenticatedUser.id;

    let eventsCount = myEvents && myEvents.filter(event => event.creator_id === myID)
      .length;
    const user = this.props.authentication.authenticatedUser
    // console.log(this)
    await this.props.dispatch(checkSubscription(user.id)).then(res => {
      if (!res.message && !res.is_premium) {
        this.setState({ payModal: true });
      } else {
        if (res.ending && (res.next * 1000 < new Date().getTime())) {
          this.setState({ payModal: true });
        } else {
          this.setState({ payModal: false });
          if (eventsCount === 0) {
            this.setState({
              isGhost: true
            });
          }
          // console.log('isGhost', this.state.isGhost)
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => position);
          }
        }
      }
    });
  };

  render() {
    
    const { history, authentication, openHouseModal } = this.props;
    const { authenticatedUser } = authentication;
    const { events, id: myID } = authenticatedUser;
    let openShowings = [];
    if(events){
    openShowings = events.filter(
      a => !a.end_time && a.start_time && a.creator_id === myID
    );
    }
    const isShowingOpen = !(openShowings.length === 0);

    const eventsCount = events && events.filter(event => event.creator_id === myID)
      .length;

    const isEventsCountZero = eventsCount === 0;

    // console.log(events)
    console.log('isShowingOpen', isShowingOpen, openShowings)
    return (
      <div className="showings-app">
        <MenuBar />

        <div className="showings-body">
          <div className="showings-cards">
            {/* ONLY SHOW EVENTS THAT I CREATED AND HAVE ATTENDEES*/}

            {events && listEvents(events, myID, this.state.loadIndex, this.props.history)}
          </div>
          {!isEventsCountZero ? (
            <div className="showings-actions">
              {eventsCount > 2 && eventsCount > this.state.loadIndex + 1 ? (
                <Button color="secondary" onClick={this.handleLoadMore}>
                  VIEW MORE SHOWINGS
                </Button>
              ) : (
                ""
              )}
            </div>
          ) : (
            <GhostShowing />
          )}
          {isShowingOpen ? (
            <div className="showings-start-new">
              <Button
                variant="contained"
                color="primary"
                onClick={() =>
                  history.push(`/showings/timer/${openShowings[0].id}`)
                }
                style={{
                  transform: "scale(1.3)",
                  margin: "30px"
                }}
              >
                current showing
              </Button>
            </div>
          ) : (
            <div className="showings-start-new">
              <Button
                variant="contained"
                disabled={this.state.isSent}
                color="primary"
                onClick={e => this.handleCreateNewShowing(e, history, false)}
                style={{
                  transform: "scale(1.3)",
                  margin: "30px",
                  width: "181.33px"
                  // height: '21px'
                }}
              >
                {this.state.isSent ? (
                  <CircularProgress
                    style={{
                      width: "25px",
                      height: "25px",
                      marginTop: "-2px"
                    }}
                  />
                ) : (
                  "create showing"
                )}
              </Button>
              <Button
                variant="text"
                color="primary"
                onClick={() =>
                  this.props.dispatch({ type: "OPEN_HOUSE_MODAL" })
                }
              >
                Open House
              </Button>
            </div>
          )}
        </div>
        {this.state.payModal ? (
          <MembershipModal
            onClose={() => this.setState({ payModal: false, isSent: false })}
            onFailure={() => {
              this.setState({ payModal: false, isSent: false });
              this.props.dispatch(
                openSnackBar({
                  message: "Error purchasing membership"
                })
              );
            }}
            onSuccess={() => {
              this.setState({ payModal: false });
              this.props.dispatch(
                openSnackBar({
                  message: "Membership Purchased"
                })
              );
                this.setState({ isSent: false });
            }}
          />
        ) : null}
        <Dialog
          open={openHouseModal}
          onClose={() => {
            this.props.dispatch({ type: "OPEN_HOUSE_MODAL" });
          }}
        >
          <Card>
            <CardContent>
              <h3 style={{ margin: "0" }}>Start an open house</h3>
            </CardContent>
            <CardContent>
              <span>How long is the open house?</span>
            </CardContent>
            <form
              onSubmit={e => {
                e.preventDefault();
                this.handleCreateNewShowing(e, history, true);
                this.props.dispatch({ type: "OPEN_HOUSE_MODAL" });
              }}
            >
              <CardContent>
                <TextField
                  id="open_house_time_hour"
                  label="Hours"
                  onChange={e => {
                    const val = e.target.value.replace(/[^0-9]/g, "");
                    this.setState({ openHouseHours: val });
                  }}
                  value={this.state.openHouseHours}
                  type="tel"
                  required
                  fullWidth
                />
                {/* <TextField
                  id="open_house_time_minutes"
                  label="Minutes"
                  onChange={e => {
                    const val = e.target.value.replace(/[^0-9]/g, '')
                    this.setState({ openHouseMinutes: val })
                  }}
                  value={this.state.openHouseMinutes}
                  type="tel"
                  required
                  fullWidth
                /> */}
              </CardContent>
              <CardContent>
                <div style={{ display: "flex" }}>
                  <div style={{ flexGrow: 1 }} />
                  <Button color="primary" variant="contained" type="submit">
                    Submit
                  </Button>
                </div>
              </CardContent>
            </form>
          </Card>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = store => {
  return {
    authentication: store.authentication,
    openHouseModal: store.openHouseModal
  };
};
const mapActionsToProps = dispatch => {
  return {
    toggleDrawer: () => dispatch({ type: "DRAWER_TOGGLED", payload: true }),
    dispatch
  };
};

export default withDrawer(
  compose(connect(mapStateToProps, mapActionsToProps))(Showings)
);
